import { makeStyles } from '@material-ui/styles';

/** Matches ecommerce page headers (e.g. Participants `.headerLabel`) */
export const useTimesheetPageStyles = makeStyles({
  pageTitle: {
    fontFamily: 'Raleway, sans-serif',
    fontWeight: 600,
    fontSize: 20,
    lineHeight: 1.4,
    color: '#000',
    margin: 0,
  },
});
